import { useEffect } from 'react';

import { useQuery } from '@apollo/client';

import { useLocation, useNavigate } from 'js/lib/useRouter';

import { updateURLParams } from 'bundles/teams-v2/components/utils';
import GetActiveSiteWidePromotion from 'bundles/teams-v2/queries/GetActiveSiteWidePromotion.graphql';
import type { GetActiveSiteWidePromotionQuery } from 'bundles/teams-v2/queries/__generated__/GetActiveSiteWidePromotion';

const SITE_PROMO_PARAM = 'sitePromo';

export const useActiveSiteWidePromotion = (): string | null => {
  const location = useLocation();
  const navigate = useNavigate();

  const { data } = useQuery<GetActiveSiteWidePromotionQuery>(GetActiveSiteWidePromotion);

  const activeSiteWidePromotionId =
    data?.EnterprisePromotionQueries?.activeSiteWidePromotion?.enterprisePromotionId ?? null;

  useEffect(() => {
    const currentQuery = location.query || {};
    if (activeSiteWidePromotionId && !currentQuery[SITE_PROMO_PARAM]) {
      updateURLParams(navigate, location.pathname, { ...currentQuery, [SITE_PROMO_PARAM]: '1' });
    }
  }, [activeSiteWidePromotionId, location.pathname, location.query, navigate]);

  return activeSiteWidePromotionId;
};
